<h2 mat-dialog-title  class="text-lg font-bold mb-1">Ubicación</h2>
<mat-dialog-content class="modal-content">
    <div class="map-container">
        <div class="map-frame">
        <div id="mapDetailTo"></div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="align-left" (click)="onClose()">Cerrar</button>
</mat-dialog-actions>